module.exports = __webpack_public_path__ + "static/media/loom.ee77132f.svg";